module.exports = __webpack_public_path__ + "img/hairong.e573204a.jpg";